import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { ResponsiveBar } from '@nivo/bar'

import { minutesToText } from 'modules/core/lib/duration'
import i18n from 'modules/core/lib/i18n'

import {
  SMALL_BAR_HEIGHT,
  SMALL_BAR_RADIUS,
  barTheme,
} from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/lib/barsHelper'

import { colors, generateData, keys } from './generateData'

interface Props {
  balancePoolMinutes: number
  balancePoolCapacity: number
}

const Bar = ({ balancePoolMinutes, balancePoolCapacity }: Props) => {
  const data = generateData(balancePoolMinutes, balancePoolCapacity)
  const hasLimit = balancePoolCapacity > 0 && balancePoolCapacity !== Infinity
  const hasBalancePoolMinutes = balancePoolMinutes > 0
  const showLimit = hasLimit && hasBalancePoolMinutes
  const limitText = i18n.t('clock_in.balance_header.capacity_limit', {
    time: minutesToText(balancePoolCapacity),
  })

  return (
    <Box>
      {showLimit ? (
        <Box alignItems="flexStart">
          <Text color="grey700" size="100" ellipsis>
            {limitText}
          </Text>
        </Box>
      ) : (
        <Box padding="s8" />
      )}
      <Box style={{ height: `${SMALL_BAR_HEIGHT}px` }}>
        <ResponsiveBar
          data={[data]}
          keys={keys}
          layout="horizontal"
          colors={colors}
          enableLabel={false}
          isInteractive={false}
          animate={false}
          borderRadius={SMALL_BAR_RADIUS}
          innerPadding={2}
          theme={barTheme}
        />
      </Box>
    </Box>
  )
}

export default Bar
